import React from 'react'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { UserAccessToFeatures } from '../../Settings/UserRolesConfiguration/userAccessToFeaturesTypes'

export type CandidateListTableProps = {
  endIndex: number
  searchStr: string
  startIndex: number
}
export type CandidateAppliedForList = {
  id: number
  jobCode: string
  positionVacant: string
  minimumExperience: string
  description: string | null
  opendDate: string
  expiryDate: null | string
  noOfRequirements: number
  offered: number
  remaining: number
  status: string
}
export type sourceLookUp = {
  sourceName: string
  sourceType: string
  displayOrder: null
  sourceLookUpId: number
}
// used in other components - used in interview status report
export type country = {
  id: number
  name: string
  mobileCode: string
  countryCode: string
}

export type CandidateListsView = {
  personId: number
  firstName: string
  lastName: string
  middleName: null
  fullName: string
  mobile: string
  phone: null
  email: string
  qualification: null
  dob: string
  skypeId: null
  currentEmployer: string
  currentLocation: null
  createdDate: null
  addressDto: null
  id: null
  experience: string
  skills: string
  appliedFor: CandidateAppliedForList
  sourcelookUp: sourceLookUp
  documentList: []
  skillData: null
  appliedForVacancy: string
  resumePath: null | string
  otherDocumentPath: null
  cadidateInterviewStatus: string
  recruiter: string
  technology: string
  updatedDate: null
  addedDate: null
  countryId: null
  country: country
  interviewRound: number | string
}

export type CandidateViewTotalInfo = {
  size: number
  list: CandidateListsView[]
}
export interface IncomingAllJobVacanciesList {
  size: number
  list: CandidateAppliedForList[]
}

export interface GetAllJobVacanciesParams {
  endIndex: number | null
  startIndex: number | null
  status: string | null
  searchJobTitle: string | null
  vendorEmployeeId: string | null
  isVendor: boolean | null
}

export interface EmployeeListItem {
  id: number
  profilePicPath: string
  firstName: string
  lastName: string
  emailId: string
  designation: string
  fullName: string
}

export interface IncomingCompaniesData {
  companyId: number
  companyName: string
}

// to differentitate add technology and add candidate page
export enum CurrentAddCandidatePage {
  addCandidate = 'Add New Candidate',
  addTechnology = 'Add New Technology',
  addInternTech = 'Intern Technology List',
}

export interface IncomingEditCandidateData {
  candidateName: string
  candidateFirstName: string
  candidateLastName: string
  candidateEmail: string
  experience: string
  skills: string
  mobile: string
  appliedFor: CandidateAppliedForList
  sourceType: string
  sourceName: string
  uploadResume: null | string
  otherDocs: null
  status: string
  candidateId: number | string
  appliedForLookUp: string
  vacancyId: number
  scheduleDate: null
  scheduleTime: null | string
  interviewerEmailid: null
  receipentEmailId: null
  description: null
  scheduleFlag: null | string
  interviewRound: null
  interviewersDTOList: null | Array<string>
  interviewerId: null
  interviewType: null
  interviewStatus: null
  dob: string
  timelineStatus: null
  technology: string
  recruiter: null | string
  ctc: string
  ectc: string
  np: string
  reason: string
  skypeId: null | string
  currentEmployer: null | string
  currentLocation: string
  sendMailToCandidate: null
  sendMailToInterviewer: null
  sendMessageToCandidate: null
  sendMessageToInterviewer: null
  jobTypeName: string
  pan: null | string
  adhar: null | string
  linkedin: null | string
  countryId: number
  country: country
  notifications: string
  contactDetails: null
  countryCode: number
}

export interface paginationIndexType {
  startIndex: number
  endIndex: number
}
export type CandidateListSliceState = {
  paginationData: paginationIndexType

  isLoading: ApiLoadingState
  listSize: number
  candidateViewDetails: CandidateListsView
  allCandidateViewDetails: CandidateListsView[]
  allCountryDetails: country
  allEmployeeDetailsList: EmployeeListItem[]
  empCountries: country[]
  getAllTechnology: GetAllTechnology[]
  allJobVacancies: IncomingAllJobVacanciesList
  allCompaniesData: IncomingCompaniesData[]
  currentAddCandidatePage: CurrentAddCandidatePage
  editCandidateData: IncomingEditCandidateData
  recruitersDetails: recruitersDetails[]
  UploadResumeResponse: UploadResumeType
  filterData: viewHandlerProps
  screenToggle: string
  getAllStatus: GetAllStatus[]
}

//used in other components - used in interview status report also
export type GetAllTechnology = {
  id: number
  name: string
}
export type GetAllStatus = {
  name: string
}
export type TableProps = {
  currentPage: number
  pageSize: number
  searchInput: string
  userAccess: UserAccessToFeatures | undefined
  searchData: (
    size: number,
    page: number,
    config?: CandidateListConfigType,
  ) => void
}

export interface viewHandlerProps {
  candidateStatus: string
  endIndex: number
  selectionCountry: string
  selectionTechnology: string
  startIndex: number
  recruiter: string
  experience: string
  selectionStatus: string
  fromDate: string
  toDate: string
  searchByMultipleFlag: string
  interviewRound: number | string
  isResumeMatcher?: string
  isExternalCreated?: string | boolean
  appliedFor?: string
  //vendorName?: string
}

export type CandidateListConfigType = Partial<
  Omit<viewHandlerProps, 'startIndex' | 'endIndex'>
>

export interface exportCandidateListProps {
  selectionStatus: string
  fromDate: string
  toDate: string
  searchByCandidateName: string
  searchByRecruiterName: string
  searchBySourceName: string
  searchByMultipleFlag: string
  candidateStatus: string
  selectionTechnology: string
  searchByExperience: string
  selectionCountry: number | string
  recruiter: string
  experience: string
  interviewRound: undefined | number | string
  isResumeMatcher: string
  isExternalCreated: string | boolean
  appliedFor?: string
}

export interface CandidateListFilterOptionsProps {
  searchKeyDownButtonHandler: (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => void
  clearButtonHandler: (e: React.MouseEvent<HTMLButtonElement>) => void
  searchButtonHandler: (e: React.MouseEvent<HTMLButtonElement>) => void
  userAccess: UserAccessToFeatures | undefined
  filterBody: viewHandlerProps
  setFilterBody: React.Dispatch<React.SetStateAction<viewHandlerProps>>
  handleExportCandidate: () => void
  setDateError: React.Dispatch<React.SetStateAction<boolean>>
  dateError: boolean
}

export enum CandidateWhatsAppNotificationsRadio {
  yes = 'Yes',
  no = 'No',
}

export enum CandidateSourceType {
  internal = 'Internal',
  external = 'External',
  Others = 'Others',
}

export enum CandidateJobTypeEnum {
  fullTime = 'Full Time',
  partTime = 'Part Time',
}

export interface AddEditCandidateTemplateProps {
  backButtonLink: string
  firstName: string
  setFirstName: React.Dispatch<React.SetStateAction<string>>
  lastName: string
  setLastName: React.Dispatch<React.SetStateAction<string>>
  aadharNumber: string
  setAadharNumber: React.Dispatch<React.SetStateAction<string>>
  panNumber: string
  setPanNumber: React.Dispatch<React.SetStateAction<string>>
  appliedFor: CandidateAppliedForList
  setAppliedFor: React.Dispatch<React.SetStateAction<CandidateAppliedForList>>
  sourceType: string
  setSourceType: React.Dispatch<React.SetStateAction<string>>
  experience: string
  setExperience: React.Dispatch<React.SetStateAction<string>>
  sourceName: string
  setSourceName: React.Dispatch<React.SetStateAction<string>>
  emailId: string
  setEmailId: React.Dispatch<React.SetStateAction<string>>
  linkedInId: string
  setLinkedInId: React.Dispatch<React.SetStateAction<string>>
  mobileCode: country
  setMobileCode: React.Dispatch<React.SetStateAction<country>>
  mobileNumber: string
  setMobileNumber: React.Dispatch<React.SetStateAction<string>>
  dob: string
  setDob: React.Dispatch<React.SetStateAction<string>>
  technology: string
  setTechnology: React.Dispatch<React.SetStateAction<string>>
  ctc: string
  setCtc: React.Dispatch<React.SetStateAction<string>>
  ectc: string
  setEctc: React.Dispatch<React.SetStateAction<string>>
  recruiterName: string
  setRecruiterName: React.Dispatch<React.SetStateAction<string>>
  skills: string
  setSkills: React.Dispatch<React.SetStateAction<string>>
  currentEmployer: string
  setCurrentEmployer: React.Dispatch<React.SetStateAction<string>>
  currentLocation: string
  setCurrentLocation: React.Dispatch<React.SetStateAction<string>>
  noticePeriod: string
  setNoticePeriod: React.Dispatch<React.SetStateAction<string>>
  skypeId: string
  setSkypeId: React.Dispatch<React.SetStateAction<string>>
  jobType: string
  setJobType: React.Dispatch<React.SetStateAction<string>>
  selectCountry: country
  setSelectCountry: React.Dispatch<React.SetStateAction<country>>
  whatsAppNotifications: string
  setWhatsAppNotifications: React.Dispatch<React.SetStateAction<string>>
  reasonForChange: string
  reasonForChangeHandler: (value: string) => void
  uploadedFile: File | undefined
  setUploadedFile: React.Dispatch<React.SetStateAction<File | undefined>>
  uploadedResumeFileName: string | null
  showEditor: boolean
  setFinalButtonEnabled: React.Dispatch<React.SetStateAction<boolean>>
  isAddFunctionality: boolean
  handleUpload?: () => Promise<void>
  clearFile?: string
  setClearFile?: React.Dispatch<React.SetStateAction<string>>
  preSelectedResume?: string
  disableUploadButton?: boolean
  setDisableUploadButton?: React.Dispatch<React.SetStateAction<boolean>>
  preFileName?: string
  setPreFileName?: React.Dispatch<React.SetStateAction<string>>
  isFileFromLocation?: boolean
  setIsFileFromLocation?: React.Dispatch<React.SetStateAction<boolean>>
  resumeAppliedFor?: string
  handlePreFileNameClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

export interface AddNewCandidateDTO {
  notifications: string
  candidateEmail: string
  mobile: string
  countryCode: number
  candidateFirstName: string
  candidateLastName: string
  adhar: string | null
  pan: string | null
  appliedFor: CandidateAppliedForList
  sourceType: string
  sourceName: string
  experience: string
  technology: string
  linkedin: string | null
  dob: string
  recruiter: string | null
  skills: string
  ctc: string
  ectc: string
  currentEmployer: string | null
  currentLocation: string
  np: string
  jobTypeName: string
  skypeId: string | null
  countryId: number
  reason: string
  scheduleFlag: string
  interviewersDTOList: []
  scheduleTime: string
}

export interface UploadCandidateResumeDTO {
  personId: number
  file: FormData
}

export interface IsEditNewCandidateEmailExistsParams {
  candidateId: number
  mailId: string
}

export interface IsEditNewCandidateMobileNumExistsParams {
  candidateId: number
  mobileNum: number
}

export interface recruitersDetails {
  id: number
  profilePicPath: string
  firstName: string
  lastName: string
  emailId: string
  designation: string
  fullName: string
  phone: string
}

export interface UploadResumeDTO {
  file: FormData
}

export interface ContactInformation {
  email: string
  phone: string
  linkedIn: string
  aadharNo: string
  panNo: string
}

export interface ParsedResume {
  firstName: string
  lastName: string
  dateOfBirth: string
  contactInformation: ContactInformation
  country: string
  city: string
  totalExperience: string
  skills: string[]
  scannedPdf: string
  currentEmployer: string
}

export interface UploadResumeType {
  parsedResume: ParsedResume
}
